export default __webpack_public_path__ + "static/media/envelope.d9186ed5.svg";